import { GlassSurface } from "@/components/ui/GlassSurface";

/**
 * Backwards-compatible glass container. Prefer GlassSurface for new code.
 */
const GlassBox = ({ children, variant = "default", ...props }) => (
  <GlassSurface variant={variant} {...props}>
    {children}
  </GlassSurface>
);

export default GlassBox;
